import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import AddPurchaseOrderModal from "./AddPurchaseOrderModal";
import {
  BRAND_COLOR,
  BRAND_HOVER,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";

const NoPurchaseOrderFound: React.FC = () => {
  const [openAddModal, setOpenAddModal] = useState(false);
  const { t } = useKivunovaTranslation();

  return (
    <Box
      sx={{
        p: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "70vh"
      }}
    >
      <Typography variant="h5" fontWeight="bold" mb={2} color="text.primary">
        {t("no-purchase-order-title", "No purchase orders found")}
      </Typography>
      <Typography color="text.secondary" mb={3}>
        {t(
          "no-purchase-order-description-line1",
          "It looks like there are no purchase orders yet."
        )}
        <br />
        {t(
          "no-purchase-order-description-line2",
          "Click below to create your first purchase order."
        )}
      </Typography>

      <Box>
        <Button
          variant="contained"
          onClick={() => setOpenAddModal(true)}
          data-testid="create-purchase-order-btn"
          sx={{
            backgroundColor: BRAND_COLOR,
            "&:hover": {
              backgroundColor: BRAND_HOVER
            },
            textTransform: "none"
          }}
        >
          {t("no-purchase-order-create-button", "Create Purchase Order")}
        </Button>
      </Box>

      <AddPurchaseOrderModal
        open={openAddModal}
        onClose={() => setOpenAddModal(false)}
      />
    </Box>
  );
};

export default NoPurchaseOrderFound;
